const questionDeps = (EAFormData, level, key) => {
  const arr = EAFormData?.[String(level)] || [];
  const found = arr.find((obj) => Object.hasOwn(obj, key));
  return found ? found[key] : null;
};

// 使用上一項的答案當作 API 呼叫的參數
export function buildParamValue(EAFormData, desc) {
  if (!desc) return undefined;

  // 判斷來源：specialParamFrom 優先，其次才是 optionsParamFrom
  const paramSource = desc.optionsParamFrom;
  const targetData = EAFormData;

  if (!paramSource) return undefined;

  // ✅ 1) 固定值：{ value: 999 } 或 { fixedValue: 999 }
  if ("value" in paramSource || "fixedValue" in paramSource) {
    const raw =
      "value" in paramSource ? paramSource.value : paramSource.fixedValue;
    return paramSource.transform ? paramSource.transform(raw) : raw;
  }

  // ✅ 2) 依賴欄位：{ level: 1, key: "equipmentCategoryId" }
  const v = questionDeps(targetData, paramSource.level, paramSource.key);
  if (v === null || v === "") return undefined; // 沒值就不帶
  return paramSource.transform ? paramSource.transform(v) : v;
}
